
export default {

    authUser(state){
        return state.authUser
    }
}